import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-form-btn',
  templateUrl: './form-btn.component.html',
  styleUrls: ['./form-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormBtnComponent {
  @Input() css?: string;
  @Input() icon!: string;
  @Input() label?: string;
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Output() onClick = new EventEmitter<void>();
}
